export const columnasAutorizaciones = [
    {
        key: "nDeSolicitud",
        label: "N° de solicitud",
        sorted: false,
        fixed: false,
        type: "link",
        hidden: false,
    },
    {
        key: "fecha",
        label: "Fecha",
        sorted: true,
        fixed: false,
        type: "date",
        hidden: false,
    },
    {
        key: "usuario",
        label: "Usuario",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "importeFormateado",
        label: "Importe",
        sorted: true,
        fixed: false,
        type: "number",
        hidden: false,
        sortKey: "currency"
    },
    {
        key: "tipo",
        label: "Tipo",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "medioDePago",
        label: "Medio De Pago",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: true,
    },
    {
        key: "estado",
        label: "Estado",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "acciones",
        label: "",
        sorted: false,
        fixed: false,
        type: "link",
        hidden: false,
    }
];
